import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '@/config/gameConfig';
import { THEME } from '@/config/theme';
import { drawArcadeBackground, addTextGlow } from '@/utils/arcadeBackground';
import { isMobileDevice } from '@/utils/mobile';
import { createBackButton, createButton } from '@/ui/buttons';

export class FriendWebPlayScene extends Phaser.Scene {
  constructor() {
    super({ key: 'FriendWebPlayScene' });
  }

  create(): void {
    if (isMobileDevice()) {
      this.scene.start('JoinScene', { notice: 'This mode requires desktop. Join via invite link or room code.' });
      return;
    }

    this.cameras.main.fadeIn(300, 5, 7, 22);
    drawArcadeBackground(this);

    const panel = this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, 700, 400, THEME.colors.backgroundLightHex, 0.9);
    panel.setStrokeStyle(3, THEME.colors.magentaHex);

    const title = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 120, 'FRIEND PLAY', {
      fontFamily: THEME.fonts.heading,
      fontSize: THEME.sizes.titleLarge,
      color: THEME.colors.cyan,
    }).setOrigin(0.5);
    addTextGlow(title, THEME.colors.cyan, 15);

    const subtitle = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 70, 'Host a lobby or join with a room code', {
      fontFamily: THEME.fonts.body,
      fontSize: THEME.sizes.bodyLarge,
      color: THEME.colors.textMuted,
    }).setOrigin(0.5);

    createButton(this, {
      x: GAME_WIDTH / 2,
      y: GAME_HEIGHT / 2 + 10,
      text: 'HOST LOBBY',
      onClick: () => {
        this.scene.start('LobbyScene', { role: 'host', mode: 'coop', totalPlayers: 2 });
      },
      style: 'primary',
      buttonType: 'normal',
    });

    createButton(this, {
      x: GAME_WIDTH / 2,
      y: GAME_HEIGHT / 2 + 90,
      text: 'JOIN LOBBY',
      onClick: () => {
        this.scene.start('JoinScene');
      },
      style: 'primary',
      buttonType: 'normal',
    });

    createBackButton(this, {
      x: 110,
      y: 70,
      onClick: () => this.scene.start('MenuScene'),
    });
  }

}
